import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-aboutSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			var slider = new Swiper (el.querySelector('.b-aboutSlider-container'), {
				slidesPerView: 1,
				spaceBetween: 0,
				// effect: 'fade',
				// loop: true,
				slideClass: 'b-posterAboutBox',
				autoplay: {
					delay: 5000,
				},
			});
		});
	});
});